import React from 'react';
import { PageFrame } from '../../components/';
import './Vote.css';

const voteSites = [
  { icon: '🌐', name: 'Minecraft Server List', reward: '+40 Coins' },
  { icon: '🎮', name: 'Planet Minecraft', reward: '+40 Coins' },
  { icon: '📊', name: 'TopG', reward: '+40 Coins' },
  { icon: '⭐', name: 'Minecraft-MP', reward: '+40 Coins' },
  { icon: '🏆', name: 'MinecraftServers.org', reward: '+40 Coins' }
];

const voteRewards = [
  { icon: '💎', name: 'Diamonds', amount: '1-16 diamonds' },
  { icon: '🥚', name: 'Spawn Eggs', amount: 'Rare mobs' },
  { icon: '⚗️', name: 'Potions', amount: 'Special effects' },
  { icon: '🗡️', name: 'Weapons', amount: 'Enchanted gear' },
  { icon: '💰', name: 'Coins', amount: '500-5000' },
  { icon: '🎁', name: 'Mystery Box', amount: 'Rare chance' }
];

const streaks = [
  { icon: '🔥', days: '7 Days', reward: '+200 Coins' },
  { icon: '⚡', days: '30 Days', reward: '+1,000 Coins' },
  { icon: '👑', days: '100 Days', reward: 'Exclusive Title & +3,000 coins' }
];

function Vote() {
  return (
    <PageFrame>
      <header className="header">
        <div className="sword-divider">
          <span className="sword-line"></span>
          <span className="sword-icon">🗳️</span>
          <span className="sword-line"></span>
        </div>
        <h1 className="page-title">Vote for Voxale</h1>
        <p className="page-subtitle">Support us and earn rewards every day!</p>
      </header>

      <div className="stats-bar">
        <div className="stat">
          <span className="stat-number">5</span>
          <span className="stat-label">Vote Sites</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat">
          <span className="stat-number">24h</span>
          <span className="stat-label">Cooldown</span>
        </div>
        <div className="stat-divider"></div>
        <div className="stat">
          <span className="stat-number">∞</span>
          <span className="stat-label">Gratitude</span>
        </div>
      </div>

      <div className="vote-sites">
        {voteSites.map((site, index) => (
          <div className="vote-site" key={index}>
            <div className="vote-site-info">
              <div className="vote-site-icon">{site.icon}</div>
              <div>
                <h3 className="vote-site-name">{site.name}</h3>
                <p className="vote-site-reward">{site.reward}</p>
              </div>
            </div>
            <a href="#" className="btn btn-emerald">Vote</a>
          </div>
        ))}
      </div>

      <div className="vote-rewards">
        <h3 className="section-title" style={{ marginTop: 0 }}>
          <span className="title-line"></span>
          Vote Key Rewards
          <span className="title-line"></span>
        </h3>
        <p style={{ textAlign: 'center', color: 'var(--wood-medium)', marginBottom: '1rem' }}>
          Open Vote Crates at spawn with your Vote Keys!
        </p>
        <div className="reward-grid">
          {voteRewards.map((reward, index) => (
            <div className="reward-item" key={index}>
              <div className="reward-icon">{reward.icon}</div>
              <div className="reward-name">{reward.name}</div>
              <div className="reward-amount">{reward.amount}</div>
            </div>
          ))}
        </div>
      </div>

      <h3 className="section-title">
        <span className="title-line"></span>
        Vote Streaks
        <span className="title-line"></span>
      </h3>

      <div className="features" style={{ marginTop: '1rem' }}>
        {streaks.map((streak, index) => (
          <div className="feature" key={index}>
            <div className="feature-icon">{streak.icon}</div>
            <div className="feature-content">
              <h3 className="feature-title">{streak.days}</h3>
              <p className="feature-desc">{streak.reward}</p>
            </div>
          </div>
        ))}
      </div>
    </PageFrame>
  );
}

export default Vote;
